import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=1dc795a8&scoped=true&"
import script from "./invoices.vue?vue&type=script&lang=js&"
export * from "./invoices.vue?vue&type=script&lang=js&"
import style0 from "./invoices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./invoices.vue?vue&type=style&index=1&id=1dc795a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc795a8",
  null
  
)

export default component.exports